"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAM_LEVEL_SHORT_LABELS = exports.TEAM_LEVEL_LABELS = exports.TEAM_LEVELS = exports.ROLE_LABELS = exports.ROLES = void 0;
exports.operatorRoleLabel = operatorRoleLabel;
/**
 * Ruoli degli operatori della suite (DEC-004, DEC-006, DEC-007) e livelli del
 * team di supporto (PRD-002 US-2). Identificatori in inglese, valori in italiano.
 */
exports.ROLES = ['analista', 'sviluppo', 'amministratore'];
exports.ROLE_LABELS = {
    analista: 'Analista',
    sviluppo: 'Sviluppo',
    amministratore: 'Amministratore',
};
exports.TEAM_LEVELS = ['primo', 'secondo'];
exports.TEAM_LEVEL_LABELS = {
    primo: 'Primo livello · Analisti',
    secondo: 'Secondo livello · Sviluppo',
};
/** Livello in forma breve, per il chip di ruolo accanto all'autore nel thread (#121). */
exports.TEAM_LEVEL_SHORT_LABELS = {
    primo: '1° livello',
    secondo: '2° livello',
};
/** Chip di ruolo di un operatore nel thread (#121): «Analista · 1° livello». */
function operatorRoleLabel(member) {
    return `${exports.ROLE_LABELS[member.role]} · ${exports.TEAM_LEVEL_SHORT_LABELS[member.level]}`;
}
//# sourceMappingURL=roles.js.map